import React, { useState } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { PlusIcon, MinusIcon } from "@heroicons/react/24/solid";
import _ from "lodash";
import toast from "react-hot-toast";
import {
  manageTicketCount,
  cancelPromo,
  updateTicketAssignedAttendee,
  updateTicketAssignedError,
  applyPromo,
  fetchTickets,
} from "@ticketsaction";
import { CDN_BASE_IMAGES_URL, SITE_URL } from "@constant";
import {
  priceDisplayLocally,
  getTaxDetails,
  activeTicetTier,
  classNames,
  checkForSelfAssign,
  validateEmail,
} from "@utilscommon";
import { displayDateInBrowserFormat } from "@datehandle";
import LocaleStrings from "@language";
import TicketPriceChangedPopup from "../../others/components/commonpopup";

const eventIgnoreDev = [1809168258022604, 1796105987495950, 1791940621293163]; // These dev event we need to ignore with new strip fee calculation. Once These events are completed then remove this
const eventIgnoreApp = [
  1804004828003810, 1802718411079660, 1791443559707490, 1814259710138170,
  1812028853942120, 1813913402399000, 1809210399418170, 1813268017344940,
  1816530335218080, 1810011661369050, 1804418708001680, 1797191152501470,
  1795494028893460, 1815732504889410, 1816488111770050, 1802850225652260,
  1812999892710280, 1810648289261520, 1812290540763660, 1807211304751440,
  1811395936484930, 1810523648265260, 1813256182878770, 1799567323168040,
  1809836911042670, 1815716368288140, 1814477176238730, 1815446498786970,
]; // These app event we need to ignore with new strip fee calculation. Once These events are completed then remove this
const eventIgnore =
  SITE_URL === "dev.eventify.io" ? eventIgnoreDev : eventIgnoreApp;

const TicketList = (props) => {
  const {
    // Parent
    selectedCurrency,
    selectedTag,
    eventifyFee,
    stripeFee,
    stripeFixedFee,
    callFrom,
    prepromo,
    ticketNav,
    formValues,

    // Own
    session,
    ticketArray,
    eventSettingsData,
    manageTicketsCount,
    stripeConnection,
    promoApplied,
    assignedAttendeeTickets,
    assignedAttendeeErrors,
    appuserCount,
    eventData,
    promodata,
    promoAppliedRemoved,
    clientbuildno,
  } = props;
  const [sessionlist, setsessionlist] = useState([]);
  const [showAlert, setshowAlert] = useState(false);

  let ticketAssignFlow =
    clientbuildno < 7 ? eventSettingsData?.data?.ticketassignflow ?? "" : ""; // Ticket assign flow
  const {
    hide_sales_enddate: hideSalesEndDate = false,
    combine_tax_and_price: combineTaxAndPrice = false,
    purchase_limit: purchaseLimit = null,
    hide_additional_charges: hideAdditionalCharges = false,
  } = JSON.parse(eventSettingsData?.data?.custom_settings ?? "{}");
  const closealert = () => {
    setshowAlert(!showAlert);
  };

  const handlePromoApply = (manageTickets) => {
    let promo = prepromo;

    let tickets = [];
    let ticketTotalPrice = 0;
    _.map(manageTickets, (item) => {
      let obj = {
        ticketid: item.ticketid,
        quantity: item.quantity,
        price: item.price,
      };
      tickets.push(obj);

      let ticketprice = item?.quantity * item?.price;
      ticketTotalPrice = ticketTotalPrice + ticketprice;
    });
    let manageTicketsArray = _.map(tickets, (o) => o.ticketid);

    /// Logic to check whether pre promo is required to apply on selected tickets or not.
    let callPromo = false;
    if (!_.isEmpty(promodata)) {
      if (promodata.promoaccess === "all") {
        callPromo = true;
      } else {
        let promoAccessSplit = promodata.promoaccess.split(",");
        let promoAccessArray = _.map(promoAccessSplit, (o) => parseInt(o));

        // console.log("promoAccessArray :- ", promoAccessArray);
        // console.log("manageTicketsArray :- ", manageTicketsArray);
        let commonTicket = _.intersection(promoAccessArray, manageTicketsArray);
        if (commonTicket.length > 0) {
          callPromo = true;
        }
      }
    }
    // console.log("ticketTotalPrice :- ", ticketTotalPrice);
    // console.log("promoAppliedRemoved :- ", promoAppliedRemoved);
    // console.log("promoApplied :- ", promoApplied);
    // console.log("eventSettingsData :- ", eventSettingsData);
    // console.log("callPromo1 :- ", callPromo);

    if (
      callPromo &&
      (ticketTotalPrice === 0 ||
        promoAppliedRemoved ||
        !_.isEmpty(promoApplied) ||
        (promodata?.accesstospecificbuyer &&
          !validateEmail(formValues?.email?.trim() ?? "")))
    ) {
      callPromo = false;
    }
    // console.log("callPromo :- ", callPromo);

    if (callPromo) {
      let values = {
        eventid: eventData?.eventid,
        promo: promo,
        tickets: tickets,
      };
      if (validateEmail(formValues?.email?.trim() ?? "")) {
        values.buyeremail = formValues.email.trim();
      }

      props.applyPromo(session, values, () => {});
    }
  };

  const findTicketName = (ticketIds, selectedTickets) => {
    const ticket = selectedTickets.find((t) =>
      ticketIds.includes(t.ticketid.toString())
    );
    return ticket ? ticket.name : null; // Default if not found
  };

  const isOverlapping = (
    newSession,
    existingSessionsById,
    selectedTickets,
    currentItemId
  ) => {
    let newStart = new Date(newSession.starttime).getTime();
    let newEnd = new Date(newSession.endtime).getTime();
    let overlappingSessions = [];

    for (const [itemId, sessions] of Object.entries(existingSessionsById)) {
      // Skip checking sessions from the same item.id
      if (itemId === currentItemId) continue;

      sessions.forEach((session) => {
        if (!session || session.sessionid === newSession.sessionid) return;

        let existingStart = new Date(session.starttime).getTime();
        let existingEnd = new Date(session.endtime).getTime();

        if (
          (newStart >= existingStart && newStart < existingEnd) ||
          (newEnd > existingStart && newEnd <= existingEnd) ||
          (newStart <= existingStart && newEnd >= existingEnd)
        ) {
          let ticketName = findTicketName(
            session.ticketassociated.split(","),
            selectedTickets
          );

          if (ticketName !== null) {
            overlappingSessions.push(
              `session "${session.title}" of ticket "${ticketName}"`
            );
          }
        }
      });
    }

    return [...new Set(overlappingSessions)];
  };

  const sameSessionOverlap = (item) => {
    let currentticketname = item.ticketname;
    let tempSessionList = { ...sessionlist }; // sessionlist is now an object
    let overlappingMessages = [];
    let selectedTickets = JSON.parse(JSON.stringify(manageTicketsCount));
    let foundOverlap = false;

    if (!tempSessionList[item.id]) {
      tempSessionList[item.id] = [];
    }

    item.session.forEach((session) => {
      const overlapping = isOverlapping(
        session,
        tempSessionList,
        selectedTickets,
        item.id
      );
      if (overlapping.length > 0) {
        foundOverlap = true;
        overlappingMessages.push(
          `Ticket ${currentticketname} having session "${
            session.title
          }" overlaps with ${overlapping.join(", ")}`
        );
      } else {
        tempSessionList[item.id].push(session); // store session under item.id
      }
    });

    if (foundOverlap) {
      toast.error(overlappingMessages.join(" | "));
      return false;
    }

    setsessionlist(tempSessionList);
    return true;
  };

  const handleTicketCount = (action, item) => {
    // console.log({ item });
    // console.log("action :- ", action);
    // console.log("manageTicketsCount:-", manageTicketsCount);
    let selectedTickets = JSON.parse(JSON.stringify(manageTicketsCount));
    let eventCapacity = eventSettingsData?.data?.eventcapacity;
    let eventWaitlistMode = eventSettingsData?.data?.waitlistmode; // true/false, check the event waitlist mode
    let pResponseData = ticketArray?.responsedata ?? {}; // Proposal response data. Proposal ticket
    let hostCreditLimitData = ticketArray?.hostlimit ?? {}; // Event host credit limit data to check the available limit to but that much ticket
    let issessionperticket = JSON.parse(
      eventSettingsData?.data?.session_settings ?? "{}"
    )?.single_ticket_per_session_time;
    let ticketid = item?.id;
    let ticketname = item?.ticketname;
    let tickettype = item?.tickettype;
    let price = tickettype === "paid" ? item?.price : 0;
    let qty = item?.quantity;
    let minqty = item?.minbooking;
    let maxqty = item?.maxbooking;
    let assignflow;

    // if proposal response user ticket buy, then allow only one ticket to buy.
    if (!_.isEmpty(pResponseData)) {
      maxqty = 1;
    }
    let ticketsold = item?.totalticketsold;
    let remQuantity = qty - ticketsold;
    remQuantity = remQuantity >= maxqty ? maxqty : remQuantity;

    let ticketQuantity = _.sumBy(selectedTickets, (t) => t?.quantity);
    if (purchaseLimit && action === "plus") {
      if (ticketQuantity + minqty > purchaseLimit) {
        toast.error(LocaleStrings.kPurchaseLimitText);
        return;
      }
    }

    // console.log("minqty :- ", minqty);
    // console.log("remQuantity :- ", remQuantity);

    // Check if any ticket added or not
    let check = _.filter(manageTicketsCount, (o) => o.ticketid === ticketid);
    let validity = true;
    // console.log("check :- ", check);

    if (check?.length > 0) {
      let existingCount = check?.[0]?.quantity;
      // console.log({ existingCount });
      let count =
        action === "minus"
          ? parseInt(existingCount) === parseInt(minqty)
            ? 0
            : existingCount - 1
          : existingCount + 1;
      let invalid = false;
      if (action === "minus" && count === 0) {
        let updatedSessionList = { ...sessionlist };
        delete updatedSessionList[item.id]; // Remove all sessions for this item.id
        setsessionlist(updatedSessionList);
      }
      // console.log("count :- ", count);
      // console.log({ sessionlist });

      if (count > remQuantity) {
        let mapObj = { "#max": remQuantity, "#ticketname": ticketname };
        let message = LocaleStrings.kTicketMaxQtyText.replace(
          /#max|#ticketname/gi,
          function (matched) {
            return mapObj[matched];
          }
        );
        toast.error(message);

        validity = false;
      } else {
        if (count > 0) {
          if (count < minqty) {
            let mapObj = {
              "#min": minqty,
              "#max": remQuantity,
              "#ticketname": ticketname,
            };
            let message = LocaleStrings.kTicketMinMaxQtyText.replace(
              /#min|#max|#ticketname/gi,
              function (matched) {
                return mapObj[matched];
              }
            );
            toast.error(message);
            invalid = true;
          }

          let index = _.findIndex(
            manageTicketsCount,
            (o) => o.ticketid === ticketid
          );

          selectedTickets[index].quantity = count;
          selectedTickets[index].invalid = invalid;

          // Apply the pre promo if set in the url
          if (!invalid && prepromo && prepromo !== "") {
            handlePromoApply(selectedTickets);
          }
        } else {
          selectedTickets = _.filter(
            manageTicketsCount,
            (o) => o.ticketid !== ticketid
          );
        }
      }
    } else {
      let count = action === "minus" ? 0 : minqty;

      if (count > 0 && remQuantity > 0) {
        let invalid = false;
        if (issessionperticket) {
          if (!sameSessionOverlap(item)) {
            // toast.error("same session time overlaping tickets not allowed");
            return;
          }
        }

        if (count < minqty) {
          let mapObj = {
            "#min": minqty,
            "#max": remQuantity,
            "#ticketname": ticketname,
          };
          let message = LocaleStrings.kTicketMinMaxQtyText.replace(
            /#min|#max|#ticketname/gi,
            function (matched) {
              return mapObj[matched];
            }
          );
          toast.error(message);
          invalid = true;
        }
        let childTicketsNum =
          item?.noofchildtickets && item?.noofchildtickets > 0
            ? item?.noofchildtickets
            : null;
        let hasChild = childTicketsNum ? true : false;
        let obj = {
          ticketid: ticketid,
          quantity: count,
          price: price,
          invalid: invalid,
          name: ticketname,
          type: item?.type,
          feesetting: item?.feesetting,
          taxname: item?.taxname,
          tax: item?.tax,
          isofflinepayment: item?.isofflinepayment,
          allowoverride: item?.allowoverride,
          noofchildtickets: childTicketsNum,
          haschild: hasChild,
          assignformdisplay: item?.assignformdisplay,
          usercategory: item?.usercategory,
          rsvpsessions: item?.rsvpsessions ?? [],
          ticketassignflow: item?.ticketassignflow,
          minattendees: item?.minattendees,
          tierjson: item?.tierjson,
          sessionsettings: item?.sessionsettings,
          allowphonelogin: item?.allowphonelogin ?? false,
          emailoptional: item?.emailoptional ?? false,
        };
        selectedTickets.push(obj);
        selectedTickets.forEach((ticket) => {
          if (
            activeTicetTier(ticket, eventData?.eventtimezone) &&
            activeTicetTier(ticket, eventData?.eventtimezone)?.activeTier
              ?.price !== ticket.price
          ) {
            closealert();
            // console.log(`Ticket ${ticket.ticketid} needs price update.`);
            props.fetchTickets(
              session,
              { eventid: eventData?.eventid },
              (res) => {
                // console.log(res);
                selectedTickets.forEach((selectedTicket) => {
                  const mainTicket = res?.data?.find(
                    (ticket) => ticket?.id === selectedTicket?.ticketid
                  );

                  if (
                    mainTicket &&
                    selectedTicket?.price !== mainTicket?.price
                  ) {
                    selectedTicket.price = mainTicket?.price;
                  }
                });
                props.manageTicketCount(selectedTickets);
              }
            );
            // proceed to update price if needed
          }
        });

        // Apply the pre promo if set in the url
        if (!invalid && prepromo && prepromo !== "") {
          handlePromoApply(selectedTickets);
        }
      } else {
        let mapObj = {
          "#min": minqty,
          "#max": remQuantity,
          "#ticketname": ticketname,
        };
        let message = LocaleStrings.kTicketMinMaxQtyText.replace(
          /#min|#max|#ticketname/gi,
          function (matched) {
            return mapObj[matched];
          }
        );
        toast.error(message);
        validity = false;
      }
    }
    let assignarray = [];
    let genralarray = [];
    _.map(selectedTickets, (item) => {
      assignarray.push(item?.ticketassignflow);
      if (item?.type !== "addon") {
        genralarray.push(item?.ticketassignflow);
      }
    });

    // checking for selfassign means one general ticket with one or more addon ticket
    let availableForSelfAssign = checkForSelfAssign(selectedTickets);
    if (
      (assignarray.includes("beforepayment") && !availableForSelfAssign) ||
      (availableForSelfAssign && genralarray.includes("beforepayment"))
    ) {
      assignflow = "beforepayment";
    } else {
      assignflow = "afterpayment";
    }

    let assignableTotalTicket = 0;
    _.forEach(selectedTickets, (obj) => {
      if (obj?.type === "general") {
        let ticketQuantity =
          obj?.noofchildtickets > 0 ? obj?.noofchildtickets : obj?.quantity;

        assignableTotalTicket = assignableTotalTicket + ticketQuantity;
      }
    });
    // console.log("assignableTotalTicket :- ", assignableTotalTicket);

    // Check the available host credit limit to buy that much ticket
    if (
      hostCreditLimitData?.total_userlimit_credits &&
      hostCreditLimitData?.total_userlimit_credits_used
    ) {
      let hostCredit = hostCreditLimitData?.total_userlimit_credits;
      let usedCredit = hostCreditLimitData?.total_userlimit_credits_used;
      let availableCredit =
        hostCredit > usedCredit ? hostCredit - usedCredit : 0;

      if (assignableTotalTicket > availableCredit) {
        validity = false;
        toast.error(
          availableCredit > 0
            ? _.replace(
                LocaleStrings.kHostCreditLimitLeftText,
                /###LEFTQUANTITY###/g,
                availableCredit
              )
            : LocaleStrings.kHostCreditLimitUsedText
        );
        return;
      }
    }

    // Check event capacity and not allow to buy this ticket if capacity is full
    if (eventCapacity > 0 && eventWaitlistMode === false) {
      let totalAppuser = appuserCount?.data?.totalusers;
      let leftCapacity =
        eventCapacity > totalAppuser ? eventCapacity - totalAppuser : 0;

      if (assignableTotalTicket > leftCapacity) {
        validity = false;
        toast.error(
          leftCapacity > 0
            ? _.replace(
                LocaleStrings.kEventCapacityLeftText,
                /#leftquantity/g,
                leftCapacity
              )
            : LocaleStrings.kEventCapacityFullTicketText
        );
        return;
      }
    }

    if (validity) {
      // console.log("here.....", selectedTickets, assignflow, validity);

      // Logic to add RSVP session tab dynamic if any selected ticket has the rsvp session list. Only for beforepayment setting
      if (
        (clientbuildno > 6 ? assignflow : ticketAssignFlow) === "beforepayment"
      ) {
        let hasRSVPSessions = false;
        _.map(selectedTickets, (o) => {
          if (o?.rsvpsessions?.length > 0) {
            hasRSVPSessions = true;
          }
        });

        let checks = _.filter(ticketNav?.flow, (o) => o?.key === "session");
        // console.log("checks:- ", checks);
        // console.log("hasRSVPSessions:- ", hasRSVPSessions);

        if (checks?.length > 0) {
          if (!hasRSVPSessions) {
            props.updateNavWithSession(
              "removesessiontab",
              clientbuildno > 6 ? assignflow : ticketAssignFlow
            );
          }
        } else {
          if (hasRSVPSessions) {
            props.updateNavWithSession(
              "addsessiontab",
              clientbuildno > 6 ? assignflow : ticketAssignFlow
            );
          }
        }
      }

      // let paidTicketDetails = _.filter(selectedTickets, (o) => o.price > 0);

      // Logic to remove applied promo code if related ticket or paid ticket quantity is 0
      if (!_.isEmpty(promoApplied)) {
        let promoApplyTo = promoApplied?.applyto ?? [];

        if (selectedTickets?.length === 0) {
          props.cancelPromo({});
        }

        if (promoApplyTo.length > 0) {
          let promoAppliedTicket = _.map(promoApplyTo, (o) =>
            parseInt(o.ticketid)
          );
          let checkTicket = _.filter(selectedTickets, (o) =>
            _.includes(promoAppliedTicket, o.ticketid)
          );

          if (checkTicket?.length === 0) {
            props.cancelPromo({});
          }
        }
      }

      props.manageTicketCount(selectedTickets);

      // Here check if ticket quantity minus and attendee is assigned to ticket. This is for before payment assign attendee
      if (
        !_.isEmpty(assignedAttendeeTickets) &&
        ((clientbuildno > 6 ? assignflow : ticketAssignFlow) ===
          "beforepayment" ||
          item?.ticketassignflow === "beforepayment")
      ) {
        // console.log("check1 :- ", check);
        if (selectedTickets?.length === 0) {
          props.updateTicketAssignedAttendee({});
          props.updateTicketAssignedError({});
        } else {
          if (check?.length > 0 && action === "minus") {
            let hasChild = check?.[0]?.haschild ?? false;
            let ticketid = check?.[0]?.ticketid;
            let leftqty = check?.[0]?.quantity - 1;
            let update = false;

            if (assignedAttendeeTickets?.[ticketid]) {
              if (hasChild) {
                // Remove assigned ticket all data (has child tickets)
                // console.log("all remove parent ticket");
                delete assignedAttendeeTickets[ticketid];
                delete assignedAttendeeErrors[ticketid];
                update = true;
              } else {
                if (leftqty === 0) {
                  // Remove assigned ticket all data
                  // console.log("all remove");
                  delete assignedAttendeeTickets[ticketid];
                  delete assignedAttendeeErrors[ticketid];
                  update = true;
                } else if (
                  leftqty < assignedAttendeeTickets?.[ticketid]?.length
                ) {
                  // Remove assigned ticket last data
                  // console.log("last remove");

                  let maxTindex = _.maxBy(
                    assignedAttendeeTickets[ticketid],
                    function (o) {
                      return o?.index;
                    }
                  );
                  let checkIndex = _.findIndex(
                    assignedAttendeeTickets[ticketid],
                    (o) => {
                      return _.isEqual(o, maxTindex);
                    }
                  );
                  // console.log("checkIndex :- ", checkIndex);

                  let values = _.filter(
                    assignedAttendeeTickets[ticketid],
                    (o, i) => i !== checkIndex
                  );
                  let errors = _.filter(
                    assignedAttendeeErrors[ticketid],
                    (o, i) => i !== checkIndex
                  );

                  assignedAttendeeTickets[ticketid] = [...values];
                  assignedAttendeeErrors[ticketid] = [...errors];
                  // assignedAttendeeTickets?.[ticketid]?.pop();
                  // assignedAttendeeErrors?.[ticketid]?.pop();
                  update = true;
                } else {
                  // _.forEach(assignedAttendeeTickets?.[ticketid], (o, i) => {
                  //   o.index = o?.index - 1;
                  // });
                  // _.forEach(assignedAttendeeErrors?.[ticketid], (o, i) => {
                  //   o.index = o?.index - 1;
                  // });
                  // update = true;
                }
              }

              if (update) {
                // console.log(
                //   "assignedAttendeeTickets 2 :- ",
                //   assignedAttendeeTickets
                // );
                // console.log(
                //   "assignedAttendeeErrors 2 :- ",
                //   assignedAttendeeErrors
                // );
                props.updateTicketAssignedAttendee(assignedAttendeeTickets);
                props.updateTicketAssignedError(assignedAttendeeErrors);
              }
            }
          } else if (action === "plus") {
            let groupTicketsArr = _.filter(selectedTickets, (o) => {
              return o?.noofchildtickets;
            });
            let generalTicketsArr = _.filter(selectedTickets, (o) => {
              return o?.type !== "addon";
            });
            let totalGeneralTickets = _.sumBy(generalTicketsArr, function (o) {
              return o?.quantity;
            });
            let addonTicketsArr = _.filter(selectedTickets, (o) => {
              return o?.type === "addon";
            });
            let totalAddonTickets = _.sumBy(addonTicketsArr, function (o) {
              return o?.quantity;
            });

            if (groupTicketsArr?.length === 0 && totalGeneralTickets === 1) {
              let gTId = generalTicketsArr?.[0]?.ticketid ?? 0;
              let email = assignedAttendeeTickets?.[gTId]?.[0]?.email ?? "";

              if (email?.trim() !== "" && totalAddonTickets > 0) {
                // console.log("addonTicketsArr :- ", addonTicketsArr);
                _.map(addonTicketsArr, (item, index) => {
                  let aotid = item?.ticketid;
                  let qty = item?.quantity;
                  let valObj = {
                    email: email?.trim().toLowerCase(),
                    ticketid: aotid,
                  };

                  if (!assignedAttendeeTickets[aotid]) {
                    let addonvalues = [];
                    let addonerrors = [];
                    for (let i = 0; i < qty; i++) {
                      addonvalues.push({ ...valObj, index: i });
                      addonerrors.push({});
                    }
                    assignedAttendeeTickets[aotid] = [...addonvalues];
                    assignedAttendeeErrors[aotid] = [...addonerrors];
                  } else {
                    for (let i = 0; i < qty; i++) {
                      let checkIndex = _.findIndex(
                        assignedAttendeeTickets[aotid],
                        (o) => {
                          return o.ticketid === aotid && o.index === i;
                        }
                      );

                      if (checkIndex >= 0) {
                        // assignedAttendeeTickets[aotid][checkIndex] = {
                        //   ...valObj,
                        //   index: i,
                        // };
                        // assignedAttendeeErrors[aotid][checkIndex] = {};
                      } else {
                        assignedAttendeeTickets[aotid].push({
                          ...valObj,
                          index: i,
                        });
                        assignedAttendeeErrors[aotid].push({});
                      }
                    }
                  }
                });
                // console.log("assigned 2 :- ", assignedAttendeeTickets);
                // console.log("formerrors 2 :- ", assignedAttendeeErrors);

                props.updateTicketAssignedAttendee(assignedAttendeeTickets);
                props.updateTicketAssignedError(assignedAttendeeErrors);
              }
            }
          }
        }
      }
    }
  };

  const renderTickets = () => {
    let ticketList = ticketArray?.data;
    if (ticketArray?.currency?.length > 0) {
      ticketList = _.filter(ticketArray?.data, (o) => {
        return o.currency === selectedCurrency || o.tickettype === "free";
      });
    }

    if (selectedTag !== "") {
      if (selectedTag === "other") {
        ticketList = _.filter(ticketArray?.data, (o) => {
          return (
            (!o?.tickettag || o?.tickettag === "") &&
            (o?.currency === selectedCurrency || o?.tickettype === "free")
          );
        });
      } else {
        ticketList = _.filter(ticketArray?.data, (o) => {
          return (
            o?.tickettag === selectedTag &&
            (o?.currency === selectedCurrency || o?.tickettype === "free")
          );
        });
      }
    }

    let eventCapacity = eventSettingsData?.data?.eventcapacity;
    let eventWaitlistMode = eventSettingsData?.data?.waitlistmode; // true/false, check the event waitlist mode
    let totalAppuser = appuserCount?.data?.totalusers;
    let noSeatLeft = false;
    if (
      eventCapacity > 0 &&
      eventWaitlistMode === false &&
      totalAppuser >= eventCapacity
    ) {
      noSeatLeft = true;
    }

    return _.map(ticketList, (ticket, index) => {
      let ticketId = ticket.id;
      let ticketCode = ticket.tickecode;
      let ticketName = ticket.ticketname;
      let ticketCurrency = ticket.currency;
      let ticketType = ticket.tickettype;
      let ticketPrice = ticket.price;
      let ticketPaymentMode = ticket.isofflinepayment;
      let ticketEndDate = ticket.saleenddate;
      let ticketDesc = ticket.ticketdesc;
      let ticketFeeSetting = ticket.feesetting;
      let ticketGenre = ticket.type;
      let ticketTag = ticket.tickettag;
      let ticketColor = ticket.colorcode;
      let ticketQuantity = ticket?.quantity ?? 0;
      let childTickets = ticket?.noofchildtickets ?? 0;
      let ticketSoldQuantity = ticket?.totalticketsold ?? 0;
      let isSoldOut =
        ticketQuantity > ticketSoldQuantity &&
        !JSON.parse(ticket?.othersettings ?? "{}")?.soldout
          ? false
          : true;
      let waitlist = ticket?.waitlistmode ?? 0;
      let capacity = ticket?.capacity ?? 0;
      let iswaitlist = false;
      let waitingcount = 0;
      let confirmcount = 0;
      let buyerCountry =
        formValues?.country && formValues?.country !== ""
          ? formValues?.country
          : ticketArray?.country ?? "";

      let taxCalculation = getTaxDetails(
        ticket,
        eventSettingsData,
        buyerCountry
      );
      let mainPriceWithTax = taxCalculation?.priceWithTax ?? 0;
      let mainTaxAmount = taxCalculation?.taxAmount ?? 0;
      let mainTaxName = taxCalculation?.taxName ?? "";

      // Calculate stripe fee charges
      let mainFeeAmount = 0;
      if (
        ticketFeeSetting === "passon" &&
        ((ticketPaymentMode !== 1 && stripeConnection?.data?.stripeaccountid) ||
          callFrom === "admin")
      ) {
        let percentageInPoints = stripeFee / 100;
        let buyerPay =
          (parseFloat(mainPriceWithTax) +
            parseFloat(eventifyFee) +
            parseFloat(stripeFixedFee)) /
          (1 - percentageInPoints);
        if (_.includes(eventIgnore, parseInt(eventData?.eventid))) {
          buyerPay = parseFloat(mainPriceWithTax);
        }
        let stripeCharge =
          buyerPay * percentageInPoints + eventifyFee + stripeFixedFee;
        mainFeeAmount = callFrom === "admin" ? eventifyFee : stripeCharge;
      }

      let ticketCheck = _.filter(
        manageTicketsCount,
        (o) => o.ticketid === ticketId
      );
      let ticketCount = ticketCheck?.length > 0 ? ticketCheck[0].quantity : 0;
      // check if the waitlist ticket is avilable or not if wailist then check current wailist count
      if (waitlist) {
        let currentCount = ticketCount;
        ticketSoldQuantity =
          childTickets !== 0
            ? ticketSoldQuantity * childTickets
            : ticketSoldQuantity;
        currentCount =
          childTickets !== 0 ? currentCount * childTickets : currentCount;
        iswaitlist = capacity < ticketSoldQuantity + currentCount;
        if (ticketSoldQuantity >= capacity) {
          waitingcount = currentCount;
          confirmcount = 0;
        } else {
          waitingcount = ticketSoldQuantity + currentCount - capacity;
          confirmcount = currentCount - waitingcount;
        }
      }
      let tierbased = JSON.parse(ticket?.tierjson ?? "[]")?.length > 1 ?? false;
      let displayTicketPrice = ticketPrice;
      if (combineTaxAndPrice && !hideAdditionalCharges) {
        displayTicketPrice = ticketPrice + mainTaxAmount + mainFeeAmount;
      }

      // Calculate ticket price after pre promo applied
      let newTicketPrice = "";
      let discountTaxAmount = 0;
      let discountTaxName = "";
      let discountFeeAmount = 0;
      if (!_.isEmpty(promodata)) {
        let couponType = promodata?.coupontype ?? "";
        let usagesType = promoApplied?.usagetype ?? "";
        let discountRate = promodata?.couponrate ?? 0;

        let prePromoAppliedAmount = false;
        if (promodata.promoaccess === "all") {
          prePromoAppliedAmount = true;
        } else {
          let promoAccessSplit = promodata.promoaccess.split(",");
          let promoAccessArray = _.map(promoAccessSplit, (o) => parseInt(o));
          if (_.includes(promoAccessArray, parseInt(ticketId))) {
            prePromoAppliedAmount = true;
          }
        }

        if (prePromoAppliedAmount) {
          let discountAmount = 0;

          if (couponType === "percentage") {
            if (usagesType === "perorder") {
              // Discount on total order amount
              discountAmount = (ticketPrice * discountRate) / 100;
            } else {
              // Discount on per ticket amount
              discountAmount = (ticketPrice * discountRate) / 100;
            }
          } else {
            if (usagesType === "perorder") {
              // Discount on total order amount
              discountAmount = discountRate;
            } else {
              // Discount on per ticket amount
              discountAmount = discountRate;
            }
          }

          let ticketPriceAfterDiscount = ticketPrice - discountAmount;
          let taxCalculationAfterDiscount = getTaxDetails(
            { ...ticket, price: ticketPriceAfterDiscount },
            eventSettingsData,
            buyerCountry
          );

          let discountPriceWithTax =
            taxCalculationAfterDiscount?.priceWithTax ?? 0;
          discountTaxAmount = taxCalculationAfterDiscount?.taxAmount ?? 0;
          discountTaxName = taxCalculationAfterDiscount?.taxName ?? "";

          if (
            ticketFeeSetting === "passon" &&
            ((ticketPaymentMode !== 1 &&
              stripeConnection?.data?.stripeaccountid) ||
              callFrom === "admin")
          ) {
            let percentageInPoints = stripeFee / 100;
            let buyerPay =
              (parseFloat(discountPriceWithTax) +
                parseFloat(eventifyFee) +
                parseFloat(stripeFixedFee)) /
              (1 - percentageInPoints);
            if (_.includes(eventIgnore, parseInt(eventData?.eventid))) {
              buyerPay = parseFloat(discountPriceWithTax);
            }
            let stripeCharge =
              buyerPay * percentageInPoints + eventifyFee + stripeFixedFee;
            discountFeeAmount =
              callFrom === "admin" ? eventifyFee : stripeCharge;
          }

          newTicketPrice = ticketPriceAfterDiscount;
          if (combineTaxAndPrice && !hideAdditionalCharges) {
            newTicketPrice =
              ticketPriceAfterDiscount + discountTaxAmount + discountFeeAmount;
          }
        }
      }

      return (
        <div
          key={`ticket_${index}`}
          className={`TICKET_LIST_CONTAINER TICKET_LIST_CONTAINER_${ticketCode} rounded-md border p-6 hover:bg-gray-100 ${
            ticketColor ? "pl-4 border-l-8" : ""
          } ${
            isSoldOut || (noSeatLeft && ticketGenre !== "addon")
              ? "border-customred"
              : "border-default"
          }`}
          style={ticketColor ? { borderLeftColor: ticketColor } : {}}
        >
          <div
            className={`TICKET_CONTAINER TICKET_CONTAINER_${ticketCode} flex sm:flex-row flex-col sm:items-center justify-between sm:space-x-2 gap-3`}
          >
            <div
              className={`TICKET_DETAILS TICKET_DETAILS_${ticketCode} flex items-center gap-2`}
            >
              {ticket?.image && (
                <img
                  className={`TICKET_IMAGE TICKET_IMAGE_${ticketCode} w-14 h-14 border rounded border-gray-150`}
                  src={`${CDN_BASE_IMAGES_URL}/${ticket?.image}`}
                  alt="ticket-img"
                />
              )}
              <div>
                <div
                  className={`TICKET_TAGS_SECTION TICKET_TAGS_SECTION_${ticketCode} flex items-center gap-1`}
                >
                  {ticketTag && (
                    <span
                      className={`TICKET_TAG TICKET_TAG_${ticketCode} tickettag`}
                      style={
                        ticketColor ? { backgroundColor: ticketColor } : {}
                      }
                    >
                      {ticketTag}
                    </span>
                  )}
                  {ticketGenre === "addon" && (
                    <span
                      className={`TICKET_GENRE TICKET_GENRE_${ticketCode} ticketgenre`}
                      style={
                        ticketColor ? { backgroundColor: ticketColor } : {}
                      }
                    >
                      {LocaleStrings.kAddon}
                    </span>
                  )}
                </div>
                <div
                  className={`TICKET_NAME TICKET_NAME_${ticketCode} custom-text-primary-xl-bold`}
                >
                  {ticketName}
                </div>
                {childTickets > 0 && (
                  <div
                    className={`TICKET_ASSOCIATED_TICKETS TICKET_ASSOCIATED_TICKETS_${ticketCode} custom-text-secondary-sm-medium italic`}
                  >
                    {_.replace(
                      LocaleStrings.kAttendeeTicketFreeText,
                      "#childickets",
                      childTickets
                    )}
                  </div>
                )}
                <div
                  className={`TICKET_PRICE_SECTION TICKET_PRICE_SECTION_${ticketCode} custom-text-theme-md-bold`}
                >
                  {ticketType === "free" ? (
                    <span className="uppercase">{LocaleStrings.kFree}</span>
                  ) : (
                    !tierbased && (
                      <>
                        <div
                          className={`TICKET_PAID_PRICE_SECTION TICKET_PAID_PRICE_SECTION_${ticketCode}`}
                          style={
                            newTicketPrice !== ""
                              ? { textDecoration: "line-through" }
                              : {}
                          }
                        >
                          <span className="uppercase">{ticketCurrency}</span>{" "}
                          {combineTaxAndPrice && !hideAdditionalCharges ? (
                            <>
                              {priceDisplayLocally(displayTicketPrice)} (
                              {LocaleStrings.kIncludingAllCharges})
                            </>
                          ) : (
                            <>
                              {priceDisplayLocally(displayTicketPrice)}
                              {!hideAdditionalCharges ? (
                                <>
                                  {mainTaxName !== "" ? (
                                    <>
                                      + {priceDisplayLocally(mainTaxAmount)} (
                                      {mainTaxName})
                                    </>
                                  ) : (
                                    ""
                                  )}
                                  {mainFeeAmount > 0 && (
                                    <>
                                      + {priceDisplayLocally(mainFeeAmount)} (
                                      {LocaleStrings.kFee})
                                    </>
                                  )}
                                </>
                              ) : (
                                ""
                              )}
                            </>
                          )}
                        </div>
                        {newTicketPrice !== "" ? (
                          <div
                            className={`TICKET_PAID_PRICE_SECTION TICKET_PAID_PRICE_SECTION_${ticketCode}`}
                          >
                            <span className="uppercase">{ticketCurrency}</span>{" "}
                            {combineTaxAndPrice && !hideAdditionalCharges ? (
                              <>
                                {priceDisplayLocally(newTicketPrice)} (
                                {LocaleStrings.kIncludingAllCharges})
                              </>
                            ) : (
                              <>
                                {priceDisplayLocally(newTicketPrice)}
                                {!hideAdditionalCharges ? (
                                  <>
                                    {discountTaxName !== "" ? (
                                      <>
                                        +{" "}
                                        {priceDisplayLocally(discountTaxAmount)}{" "}
                                        ({discountTaxName})
                                      </>
                                    ) : (
                                      ""
                                    )}
                                    {discountFeeAmount > 0 && (
                                      <>
                                        +{" "}
                                        {priceDisplayLocally(discountFeeAmount)}{" "}
                                        ({LocaleStrings.kFee})
                                      </>
                                    )}
                                  </>
                                ) : (
                                  ""
                                )}
                              </>
                            )}
                          </div>
                        ) : (
                          ""
                        )}
                      </>
                    )
                  )}
                </div>
              </div>
            </div>

            <div
              className={`TICKET_QUANTITY_SELECT_SECTION TICKET_QUANTITY_SELECT_SECTION_${ticketCode} ticket-quantity-selection`}
            >
              {isSoldOut || (noSeatLeft && ticketGenre !== "addon") ? (
                <span
                  className={`TICKET_SOLD_OUT TICKET_SOLD_OUT_${ticketCode} custom-text-secondary-md-bold uppercase`}
                >
                  {LocaleStrings.kSoldOut}
                </span>
              ) : (
                <>
                  <span
                    className={`minus ticket-count`}
                    onClick={() => {
                      handleTicketCount("minus", ticket);
                    }}
                  >
                    <MinusIcon className="w-3.5 h-3.5" />
                  </span>
                  <div className={`ticket-quantity`}>{ticketCount}</div>
                  <span
                    className={`plus ticket-count`}
                    onClick={() => {
                      handleTicketCount("plus", ticket);
                    }}
                  >
                    <PlusIcon className="w-3.5 h-3.5" />
                  </span>
                </>
              )}
            </div>
          </div>

          {/* Render tier based ticket prices */}
          {tierbased ? renderTierTickets(ticket, index) : ""}

          {/* Ticket Other info */}
          <>
            {!hideSalesEndDate && !tierbased && (
              <div
                className={`TICKET_END_DATE TICKET_END_DATE_${ticketCode} custom-text-secondary-md-normal mt-2`}
              >
                <span>{LocaleStrings.kSalesEndDateText}</span>{" "}
                {displayDateInBrowserFormat(ticketEndDate, "PP")}
              </div>
            )}

            <div
              className={`TICKET_DESCRIPTION TICKET_DESCRIPTION_${ticketCode} custom-text-secondary-md-normal mt-2  break-words`}
              dangerouslySetInnerHTML={{
                __html: ticketDesc.replace(/\n/g, "<br>"),
              }}
            />
          </>
          {/* ----------------------waitlist deatils popup ------------- */}
          {iswaitlist && ticketCount > 0 && (
            <div
              className={`TICKET_WAITLIST_NOTIFICATION TICKET_WAITLIST_NOTIFICATION_${ticketCode} bg-[#FFFBEC] px-3 py-2  border border-solid border-[#FDE68A] rounded-lg text-amber-700 mt-2`}
            >
              <div
                className={`TICKET_WAITLIST_NOTIFICATION_ICON_CONTAINER TICKET_WAITLIST_NOTIFICATION_ICON_CONTAINER_${ticketCode} text-xs flex items-center`}
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  className="lucide lucide-ticket h-3.5 w-3.5 mr-2"
                  data-lov-id="src/components/eventify/EventifyTicketSelection.tsx:131:22"
                  data-lov-name="Ticket"
                  data-component-path="src/components/eventify/EventifyTicketSelection.tsx"
                  data-component-line="131"
                  data-component-file="EventifyTicketSelection.tsx"
                  data-component-name="Ticket"
                  data-component-content="%7B%22className%22%3A%22h-3.5%20w-3.5%20mr-2%22%7D"
                >
                  <path d="M2 9a3 3 0 0 1 0 6v2a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2v-2a3 3 0 0 1 0-6V7a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2Z"></path>
                  <path d="M13 5v2"></path>
                  <path d="M13 17v2"></path>
                  <path d="M13 11v2"></path>
                </svg>{" "}
                <span>
                  {LocaleStrings.kWaitlistTicketNotificationText
                    .replaceAll("###CONFIRM###", confirmcount)
                    .replaceAll("###WAITLIST###", waitingcount)}
                </span>
              </div>
            </div>
          )}
          {showAlert && <TicketPriceChangedPopup onClose={closealert} />}
        </div>
      );
    });
  };

  const renderTierTickets = (ticket, index) => {
    let ticketId = ticket.id;
    let ticketFeeSetting = ticket.feesetting;
    let ticketPaymentMode = ticket.isofflinepayment;
    let ticketCurrency = ticket.currency;
    let ticketCode = ticket.tickecode;
    let buyerCountry =
      formValues?.country && formValues?.country !== ""
        ? formValues?.country
        : ticketArray?.country ?? "";

    return _.map(JSON.parse(ticket?.tierjson ?? "[]"), (tier, tierIndex) => {
      let activeindex = activeTicetTier(
        ticket,
        eventData?.eventtimezone
      )?.activeIndex;
      let activeprice = activeindex === tierIndex;

      let taxCalculation = getTaxDetails(
        { ...tier, tax: ticket.tax, taxname: ticket.taxname },
        eventSettingsData,
        buyerCountry
      );
      let mainPriceWithTax = taxCalculation?.priceWithTax ?? 0;
      let mainTaxAmount = taxCalculation?.taxAmount ?? 0;
      let mainTaxName = taxCalculation?.taxName ?? "";

      // Calculate stripe fee charges
      let mainFeeAmount = 0;
      if (
        ticketFeeSetting === "passon" &&
        ((ticketPaymentMode !== 1 && stripeConnection?.data?.stripeaccountid) ||
          callFrom === "admin")
      ) {
        let percentageInPoints = stripeFee / 100;
        let buyerPay =
          (parseFloat(mainPriceWithTax) +
            parseFloat(eventifyFee) +
            parseFloat(stripeFixedFee)) /
          (1 - percentageInPoints);
        if (_.includes(eventIgnore, parseInt(eventData?.eventid))) {
          buyerPay = parseFloat(mainPriceWithTax);
        }
        let stripeCharge =
          buyerPay * percentageInPoints + eventifyFee + stripeFixedFee;
        mainFeeAmount = callFrom === "admin" ? eventifyFee : stripeCharge;
      }

      let displayTierTicketPrice = tier.price;
      if (combineTaxAndPrice && !hideAdditionalCharges) {
        displayTierTicketPrice = tier.price + mainTaxAmount + mainFeeAmount;
      }

      // Calculate tier ticket price after pre promo applied
      let newTicketPrice = "";
      let discountTaxAmount = 0;
      let discountTaxName = "";
      let discountFeeAmount = 0;
      if (!_.isEmpty(promodata)) {
        let couponType = promodata?.coupontype ?? "";
        let usagesType = promoApplied?.usagetype ?? "";
        let discountRate = promodata?.couponrate ?? 0;

        let prePromoAppliedAmount = false;
        if (promodata.promoaccess === "all") {
          prePromoAppliedAmount = true;
        } else {
          let promoAccessSplit = promodata.promoaccess.split(",");
          let promoAccessArray = _.map(promoAccessSplit, (o) => parseInt(o));
          if (_.includes(promoAccessArray, parseInt(ticketId))) {
            prePromoAppliedAmount = true;
          }
        }

        if (prePromoAppliedAmount) {
          let discountAmount = 0;

          if (couponType === "percentage") {
            if (usagesType === "perorder") {
              // Discount on total order amount
              discountAmount = (tier.price * discountRate) / 100;
            } else {
              // Discount on per ticket amount
              discountAmount = (tier.price * discountRate) / 100;
            }
          } else {
            if (usagesType === "perorder") {
              // Discount on total order amount
              discountAmount = discountRate;
            } else {
              // Discount on per ticket amount
              discountAmount = discountRate;
            }
          }

          let ticketPriceAfterDiscount = tier.price - discountAmount;
          let taxCalculationAfterDiscount = getTaxDetails(
            {
              ...tier,
              tax: ticket.tax,
              taxname: ticket.taxname,
              price: ticketPriceAfterDiscount,
            },
            eventSettingsData,
            buyerCountry
          );

          let discountPriceWithTax =
            taxCalculationAfterDiscount?.priceWithTax ?? 0;
          discountTaxAmount = taxCalculationAfterDiscount?.taxAmount ?? 0;
          discountTaxName = taxCalculationAfterDiscount?.taxName ?? "";

          if (
            ticketFeeSetting === "passon" &&
            ((ticketPaymentMode !== 1 &&
              stripeConnection?.data?.stripeaccountid) ||
              callFrom === "admin")
          ) {
            let percentageInPoints = stripeFee / 100;
            let buyerPay =
              (parseFloat(discountPriceWithTax) +
                parseFloat(eventifyFee) +
                parseFloat(stripeFixedFee)) /
              (1 - percentageInPoints);
            if (_.includes(eventIgnore, parseInt(eventData?.eventid))) {
              buyerPay = parseFloat(discountPriceWithTax);
            }
            let stripeCharge =
              buyerPay * percentageInPoints + eventifyFee + stripeFixedFee;
            discountFeeAmount =
              callFrom === "admin" ? eventifyFee : stripeCharge;
          }

          newTicketPrice = ticketPriceAfterDiscount;
          if (combineTaxAndPrice && !hideAdditionalCharges) {
            newTicketPrice =
              ticketPriceAfterDiscount + discountTaxAmount + discountFeeAmount;
          }
        }
      }

      return (
        <div
          key={`ticket_tier_${index}_${tierIndex}`}
          className={classNames(
            `w-full p-3 rounded shadow-sm mt-3 border`,
            activeprice
              ? "bg-white border-theme"
              : "bg-gray-100 border-gray-200"
          )}
        >
          <div className="flex justify-between items-start">
            <div
              className={`${
                activeprice
                  ? "custom-text-secondary-md-normal"
                  : "text-gray-500"
              }`}
            >
              {tier.tiername}
              <div
                className={`text-xs mt-1 ${
                  activeprice ? " text-green-600" : "text-gray-400"
                }`}
              >
                {(activeprice
                  ? LocaleStrings.kAvailableUntilDate
                  : activeindex > index
                  ? LocaleStrings.kAvailableTillDate
                  : LocaleStrings.kAvailableFromDate
                ).replaceAll(
                  "###DATE###",
                  displayDateInBrowserFormat(
                    activeprice || activeindex > index
                      ? tier.saleenddate
                      : tier.salestartdate,
                    "PPp"
                  )
                )}
              </div>
            </div>
            <div>
              <div
                className={classNames(
                  "text-md text-right font-bold",
                  activeprice
                    ? newTicketPrice !== ""
                      ? "text-theme line-through"
                      : "text-theme"
                    : "text-gray-400 line-through"
                )}
              >
                <span className="uppercase">{ticketCurrency}</span>{" "}
                {combineTaxAndPrice && !hideAdditionalCharges ? (
                  <>
                    {priceDisplayLocally(displayTierTicketPrice)} (
                    {LocaleStrings.kIncludingAllCharges})
                  </>
                ) : (
                  <>
                    {priceDisplayLocally(displayTierTicketPrice)}
                    {!hideAdditionalCharges ? (
                      <>
                        {mainTaxName !== "" ? (
                          <>
                            <br /> {mainTaxName}
                            {" + "}
                            {priceDisplayLocally(mainTaxAmount)}
                          </>
                        ) : (
                          ""
                        )}
                        {mainFeeAmount > 0 && (
                          <>
                            <br /> {LocaleStrings.kFee}
                            {" + "}
                            {priceDisplayLocally(mainFeeAmount)}
                          </>
                        )}
                      </>
                    ) : (
                      ""
                    )}
                  </>
                )}
              </div>

              {activeprice && newTicketPrice !== "" ? (
                <div
                  className={`TIER_TICKET_PAID_PRICE_SECTION TIER_TICKET_PAID_PRICE_SECTION_${ticketCode}_${tier.tiername} custom-text-theme-md-bold`}
                >
                  <span className="uppercase">{ticketCurrency}</span>{" "}
                  {combineTaxAndPrice && !hideAdditionalCharges ? (
                    <>
                      {priceDisplayLocally(newTicketPrice)} (
                      {LocaleStrings.kIncludingAllCharges})
                    </>
                  ) : (
                    <>
                      {priceDisplayLocally(newTicketPrice)}
                      {!hideAdditionalCharges ? (
                        <>
                          {discountTaxName !== "" ? (
                            <>
                              + {priceDisplayLocally(discountTaxAmount)} (
                              {discountTaxName})
                            </>
                          ) : (
                            ""
                          )}
                          {discountFeeAmount > 0 && (
                            <>
                              + {priceDisplayLocally(discountFeeAmount)} (
                              {LocaleStrings.kFee})
                            </>
                          )}
                        </>
                      ) : (
                        ""
                      )}
                    </>
                  )}
                </div>
              ) : (
                ""
              )}
            </div>
          </div>
        </div>
      );
    });
  };

  // console.log("manageTicketsCount :- ", manageTicketsCount);
  // console.log("stripeConnection :- ", stripeConnection);

  return <div className="flex flex-col space-y-1.5">{renderTickets()}</div>;
};

const mapStateToProps = (state) => {
  let promodata = state?.ticketLists?.promodata ?? {};

  return {
    session: state.session,
    ticketArray: state.ticketLists,
    eventSettingsData: state.eventSettingsData,
    manageTicketsCount: state.manageTicketsCount,
    stripeConnection: state.stripeConnection,
    promoApplied: state.promoApplied,
    assignedAttendeeTickets: state.assignedAttendeeTickets,
    assignedAttendeeErrors: state.assignedAttendeeErrors,
    appuserCount: state.appuserCount,
    eventData: state.eventData,
    promodata,
    promoAppliedRemoved: state?.promoAppliedRemoved?.removed ?? false,
    assignflow: state.assignflow,
    clientbuildno: state?.eventData?.buildno ?? 0,
  };
};

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators(
    {
      manageTicketCount,
      cancelPromo,
      updateTicketAssignedAttendee,
      updateTicketAssignedError,
      applyPromo,
      fetchTickets,
    },
    dispatch
  );
};

export default connect(mapStateToProps, mapDispatchToProps)(TicketList);
